export class PaymentMode{
    public  ModeId : Number;
    public  ModeName : string;
}